module.exports = __webpack_public_path__ + "img/ua.d5ec692c.svg";